import React, { useEffect, useState } from "react";
import "./created-by-filter.scss";
import MultiSelectAutocomplete from "../../../../../common/components/autocomplete-component/autocomplete";
import { getTenantsList } from "../../../../../api/tenets";
interface AssignedPartnerOption {
  value: number;
  label: string;
}

interface AssignedPartnerFilterProps {
  value: number[];
  onChange: (value: number[]) => void;
  isAssignedPartnerEnabled?: boolean;
  assignedPartnerIdsError?: any;
  setAlertMessage: any;
  setAlertType: any;
  setAlertOpen: any;
}

const AssignedPartnerFilter: React.FC<AssignedPartnerFilterProps> = ({
  value,
  onChange,
  isAssignedPartnerEnabled,
  assignedPartnerIdsError,
  setAlertMessage,
  setAlertType,
  setAlertOpen
}) => {
  const [options, setOptions] = useState<AssignedPartnerOption[]>([]);

  useEffect(() => {
    if (!isAssignedPartnerEnabled) return;

    const fetchAssignedPartnerOptions = async () => {
      try {
        const response = await getTenantsList({ isActive: true, dropDown: true });
        const data = response.data.data;
        const formattedOptions = data.map((tenant: any) => ({
          value: tenant.id,
          label: `${tenant.company_name}`,
        }));

        setOptions([...formattedOptions]);
      } catch (error: any) {
        setAlertMessage(error?.response?.data?.message || "Something went wrong please try again.");
        setAlertType("error");
        setAlertOpen(true);
      }
    };

    fetchAssignedPartnerOptions();
  }, [isAssignedPartnerEnabled]);

  if (!isAssignedPartnerEnabled) return null;



  return (
    <div className="filter-select-input-wrapper">
      <MultiSelectAutocomplete
        options={options}
        selectedValues={value}
        onChange={onChange}
        placeholder="Select Assigned Partner"
      />
      {assignedPartnerIdsError && <div className="error-text">{assignedPartnerIdsError}</div>}
    </div>


  );
};

export default AssignedPartnerFilter;
